  
   <h2 mat-dialog-title>
        Add Process Stage
        <button mat-icon-button (click)="closepopUp()">
        <mat-icon>close</mat-icon>
        </button>
    </h2>    
    
  <div class="tabContainer">
    <div class="d-flex">       
    
        <div class="template-holder">
         
         <div class="right">                   
                       
           <div class="list">
    
            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" >
                <tr>
                  <th>Process Stage</th>  
                  <th>Category</th>             
                  <th class="actBtn">Action</th>
                </tr>
                <tr *ngFor="let data of stageProcessList"
                  [ngClass]="{ 'active': processStageID === data.processStageID }">
    
                  <td class="formName" style="cursor: pointer;" (click)="SelectStatus(data)">
                    {{data.processStageName}}
                  </td>     
                    <td class="formName" style="cursor: pointer;" (click)="SelectStatus(data)">
                    {{data.categoryName}}
                  </td>            
    
                  <td>
                    <button mat-button color="primary" (click)="SelectStatus(data)">Select</button>                           
                  </td>
                </tr>

              </table>
              <!-- <div *ngIf="ShowNoRecordFoundStatus" class="noRecordFound">No Record Found</div> -->
            </div>
    
           </div>
      
         </div>
      </div>  

    </div>
 
  </div>  

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="closepopUp()">Cancel</button>
    <button mat-flat-button color="primary"    
     [disabled]="!buttonForStageProcess"
    (click)="saveProcessStage()">Add
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
  </mat-dialog-actions>
  


  




